import DefaultSubtitle from './DefaultSubtitle';

export default DefaultSubtitle;
